import { render, staticRenderFns } from "./import-program-details-drawer.vue?vue&type=template&id=65d8ff9e&scoped=true"
import script from "./import-program-details-drawer.vue?vue&type=script&lang=js"
export * from "./import-program-details-drawer.vue?vue&type=script&lang=js"
import style0 from "./import-program-details-drawer.vue?vue&type=style&index=0&id=65d8ff9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d8ff9e",
  null
  
)

export default component.exports